module.exports = __webpack_public_path__ + "static/img/bg_banner3.8768110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_banner3.png
// module id = lWDn
// module chunks = 1